/**
 * Module NEUTRE « gallery » — KEEP IN SYNC avec
 * inventozen-frontpublic/src/cms-puck/gallery.ts
 *
 * Types + helpers PURES des blocs Galerie / Carousel (médiathèque multi-images).
 * `attachmentIds` = ids structurels partagés toutes langues.
 */

import { clampColumnCount, MAX_CONTENT_COLUMNS } from "@/lib/cms-puck/blocks/column-count";

export type GalleryColumns = number;
export type GalleryAspect = "auto" | "1/1" | "4/3" | "3/2" | "16/9";
export type GallerySize = "petit" | "medium" | "large" | "original";

/** @deprecated Préférer `contentColumnsGridAttrs` (colonnes dynamiques 1–12). */
export const GALLERY_GRID_CLASS: Record<2 | 3 | 4, string> = {
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
  4: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4",
};

export const GALLERY_ASPECT_CLASS: Record<Exclude<GalleryAspect, "auto">, string> =
  {
    "1/1": "aspect-square",
    "4/3": "aspect-[4/3]",
    "3/2": "aspect-[3/2]",
    "16/9": "aspect-video",
  };

export function normalizeGalleryColumns(value: unknown): number {
  return clampColumnCount(value, {
    min: 1,
    max: MAX_CONTENT_COLUMNS,
    fallback: 3,
  });
}

export function normalizeGalleryAspect(value: unknown): GalleryAspect {
  const v = String(value ?? "");
  if (v === "1/1" || v === "4/3" || v === "3/2" || v === "16/9") return v;
  return "auto";
}

export function normalizeGallerySize(value: unknown): GallerySize {
  const v = String(value ?? "");
  if (v === "petit" || v === "medium" || v === "large" || v === "original") {
    return v;
  }
  return "large";
}

/** Normalise `attachmentIds` (tableau d'ids médiathèque, ordre conservé). */
export function normalizeAttachmentIds(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  const out: string[] = [];
  const seen = new Set<string>();
  for (const raw of value) {
    const id = String(raw ?? "").trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
  }
  return out;
}
